import { useEffect, useRef, useState } from 'react';
import { useWebSocket } from './WebSocketProvider';
import { Notification, NotificationSearchResponse } from 'axiosApi/models';

export function useWebSocketNotification<T = any>(eventName: string = 'message') {
  const { subscribe, connectionState } = useWebSocket();
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [latestNotification, setLatestNotification] = useState<Notification | null>(null);
  const unsubscribeRef = useRef<(() => void) | null>(null);

  // Suscripción a eventos de notificación
  useEffect(() => {
    const handleNotification = (payload: any) => {
      payload = JSON.parse(payload); 
      try {
        const { recipient, timestamp, message, read } = payload;
        const newNotification: Notification = {
          recipient: recipient,
          message: message,
          timeStamp: timestamp,
          read: read,
        };
        setLatestNotification(newNotification);
        setNotifications((prev) => [newNotification, ...prev]);
      } catch (error) {
        console.error('Error processing notification:', error);
      }
    };

    // Subscribe immediately
    unsubscribeRef.current = subscribe<any>(eventName, handleNotification);

    return () => {
      if (unsubscribeRef.current) {
        unsubscribeRef.current();
        unsubscribeRef.current = null;
      }
    };
  }, [eventName, subscribe]);

  // Limpiar notificaciones
  const clearNotifications = () => {
    setNotifications([]);
    setLatestNotification(null);
  };

  return {
    notifications,
    latestNotification,
    clearNotifications,
  };
}
